// @flow
import isEmpty from 'lodash/isEmpty';
import { getDeviceType, getCookie } from '@fil-global/eiswagen';

import type { localeType } from './types';

import {
  SET_LOCALE,
  FETCH_LABEL,
  PAGE_TRANSITION,
  DEVICE_RESIZE_ACTION,
  SECURE_ROUTE_FLAG_ACTION,
  SET_LANGUAGE,
  SET_REGION,
} from './constants';
import { LOCALE_COOKIE, DEFAULT_LOCALE } from '../constants';

export const fetchLabelsAction = () => ({ type: FETCH_LABEL });

export const pageTransitionAction = ({ location }) => ({
  type: PAGE_TRANSITION,
  page: location ? location.pathname : '',
});

export const onDeviceResize = ({ deviceType }) => ({
  type: DEVICE_RESIZE_ACTION,
  data: deviceType || getDeviceType(),
});

export const setSelectedLocaleAction = () => ({
  type: SET_LOCALE,
  data: isEmpty(getCookie(LOCALE_COOKIE)) ? DEFAULT_LOCALE : getCookie(LOCALE_COOKIE),
});

export const updateSelectedLocaleAction = (locale: localeType) => ({
  type: SET_LOCALE,
  data: locale,
});

export const secureRouteFlagAction = isAppSecure => ({
  type: SECURE_ROUTE_FLAG_ACTION,
  data: isAppSecure,
});

export const setSelectedLanguage = language => ({
  type: SET_LANGUAGE,
  data: language,
});

export const setRegion = region => ({
  type: SET_REGION,
  data: region,
});
/**
 * !Important: setSelectedLocaleAction should be executed before fetchLabelsAction.
 */
const globalActions = [setSelectedLocaleAction, fetchLabelsAction, onDeviceResize];
const globalPageTransitionActions = [pageTransitionAction];

export { globalPageTransitionActions };
export default globalActions;
